import axios from "axios";
import CryptoJS from "crypto-js";

// Encrypted API Key
const encryptedKey = "U2FsdGVkX182IQ40Mk5/nycVREngAiSFE+7I+nHLnEtaYOTUhtmHVLxCQFuJLAL8V1BdlMu3kshMNKV9nLXrAg=="; 

const secretPassphrase = "geoCoding";

// Function to decrypt the API key
const decryptKey = (encrypted) => {
    const bytes = CryptoJS.AES.decrypt(encrypted, secretPassphrase);
    return bytes.toString(CryptoJS.enc.Utf8);
};

export const geoCodeAddress = async (req) => {

    // Decrypt the API key
    const API_KEY = decryptKey(encryptedKey);

    // Construct the URL with the address and decrypted API key
    const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(req)}&key=${API_KEY}`;

    //console.log(url);

    try {
        const response = await axios({
            method: "GET",
            url,
            headers: {
                "Content-Type": "application/json",
            },
        });

        // Extract the country code from the response
        const results = response.data.results;
        if (results && results.length > 0) {
            const countryComponent = results[0].address_components.find((component) =>
                component.types.includes("country")
            );
            if (countryComponent) {
                const countryCode = countryComponent.short_name.toUpperCase();
                //console.log("Country code:", countryCode);
                return { countryCode };
            }
        }

        return { error: "Country code not found" };
    } catch (err) {
        //console.error("Error fetching geocoding data:", err);
        return { error: "Failed to fetch geocoding data" };
    }
};
